import PageHero from "@/components/PageHero";
import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Contact & Booking"
        title="Let's plan your adventure"
        image="/images/bay-sunset-aerial.webp"
      >
        Reserve your stay now with a bespoke group package &mdash; or book a tour straight from the
        pier.
      </PageHero>
      <Contact />
    </>
  );
}
